import React, { useEffect } from "react";
import { Pagination, PaginationItem } from "@mui/material";
import { Link } from "react-router-dom";

import useStyles from "./styles";
import { useDispatch, useSelector } from "react-redux";

import { fetchFriends } from "../../../../actions/user";
const Paginate = ({ page }) => {
  const { numberOfPages } = useSelector((state) => state.allUsers);
  const { friends } = useSelector((state) => state.user);
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Pagination
      classes={{ ul: classes.ul }}
      count={numberOfPages}
      page={Number(page)}
      variant="outlined"
      color="primary"
      renderItem={(item) => (
        <PaginationItem
          {...item}
          component={Link}
          to={`/users?page=${item.page}`}
        />
      )}
    />
  );
};

export default Paginate;
